import {
  debounce,
  throttle,
  prepareApiData,
  renderTemplate,
  optionTemplate,
} from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const newsFilter = () => {
  (function ($) {
    // DOM elements
    const $form = $('c-news-filter__form');
    const $categoryInput = $('.js-news-filter-category');
    const $locationInput = $('.js-news-filter-location');
    const $resetButton = $('.js-news-filter-reset');
    const $results = $('.js-news-filter-results');
    const $fullSection = $('.js-news-filter');
    const $loader = $('.js-news-filter-loader');

    const languageCode = $('html').attr('lang') || 'en';
    const defaultUrl = `/api/search/news?language=${languageCode}`;

    // articles object
    const articles = {
      initial: [],
      current: [],
      currentUrl: defaultUrl,
      loading: false,
      loadEnd: false,
      currentPage: 0,

      setState(newState) {
        Object.assign(this, newState);
      },
    };

    // api data
    let categories = false;
    let locations = false;
    // current scroll position
    let scrollPos = window.pageYOffset;

    if (!$fullSection.length) {
      return;
    }

    // prevent the form refreshing when enter is pressed
    $form.on('submit', (e) => {
      e.preventDefault();
    });
    /**
     *
     * @param data
     * @returns {any}
     */
    const prepareDataForTemplate = (data) => {
      const ret = Object.assign({}, data);

      if ($('html').attr('lang') === 'zh-hans') {
        ret.path = `${data.path}?language=zh-hans`;
      }

      return ret;
    };
    /**
     * Populate the results div with filtered articles
     * @param {array} data array of the results of the search
     */
    const setResults = (data) => {
      let html = data.map(item => renderTemplate('news-filter-template', prepareDataForTemplate(item))).join('');
      if (html === '') {
        html = '<div class="c-team-filter__message">No results found</div>';
      }
      $results.html(html);
      $loader.html('');
    };

    /**
     * Appended loaded articles to the end of the results
     * @param {array} data array of the results of the search
     */
    const setLoaded = (data) => {
      const html = data.map(item => renderTemplate('news-filter-template', prepareDataForTemplate(item))).join('');
      $results.append(html);
    };

    const infiniteScroll = (url = defaultUrl) => {
      const page = articles.currentPage + 1;
      const symbol = url.indexOf('?') !== -1 ? '&' : '?';

      articles.setState({
        loading: true,
        currentPage: page,
      });
      $loader.html('<div class="c-team-filter__loader"></div>');

      $.ajax({
        url: `${url}${symbol}page=${page}`,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          if (data.length) {
            let current = JSON.parse(JSON.stringify(articles.current));
            current = current.concat(data);
            articles.setState({ current });
            setLoaded(data);
            articles.setState({ loading: false });
            $loader.html('');
          } else {
            articles.setState({
              loading: false,
              loadEnd: true,
            });
            $loader.html('<div class="c-team-filter__message">&mdash; End of results &mdash;</div>');
          }
        },
      });
    };

    const getFilterResults = () => {
      $.ajax({
        url: articles.currentUrl,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          articles.setState({
            current: data,
            loadEnd: false,
            currentPage: 0,
          });
          setResults(articles.current);
        },
      });
    };

    // load all articles, categories and locations
    $.when(
      // limit results to 8 newest articles
      $.ajax({
        url: defaultUrl,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          articles.setState({ initial: data, current: data });
        },
      }),
      // get all filters
      $.ajax({
        url: `/api/get/news/filters?language=${languageCode}`,
        dataType: 'json',
        success(response) {
          const filterSort = (a, b) => {
            // show the field label first
            if (a[0] === '') {
              return -1;
            }
            if (b[0] === '') {
              return 1;
            }

            // then the rest in alphabetical order
            return a[1].toLowerCase() < b[1].toLowerCase() ? -1 : 1;
          };

          categories = Object.entries(response.categories)
            .sort(filterSort)
            .map(item => ({ id: item[0], name: item[1] }));

          $categoryInput.append(categories.map(item => optionTemplate(item)).join(''));

          locations = Object.entries(response.locations)
            .sort(filterSort)
            .map(item => ({ id: item[0], name: item[1] }));

          $locationInput.append(locations.map(item => optionTemplate(item)).join(''));
        },
      }),
    ).then(
      () => {
        setResults(articles.current);
      },
    );

    // Clear all results
    $resetButton.on('click', () => {
      articles.setState({
        current: articles.initial,
        currentUrl: defaultUrl,
        currentPage: 0,
      });
      setResults(articles.current);
    });

    /**
     * Scroll listener for infinite scrolling
     */
    $(window).on('scroll', throttle(150, () => {
      // do nothing if api data hasn't loaded
      if (!articles.initial.length || !categories || !locations) return;
      // check scroll direction
      const scrollingDown = scrollPos < window.pageYOffset;
      const $section = $fullSection[0];

      // where the bottom of the news section is at the bottom of the window
      const bottomPosition = $section.getBoundingClientRect().top + $section.scrollHeight;

      const scrolledPastBottom = window.innerHeight > bottomPosition + 100;
      const sectionIsOnScreen = window.innerHeight < (bottomPosition + window.innerHeight);

      if (
        // scrolled past the bottom of the section by 100px
        scrolledPastBottom
        // section is still visible on the screen
        && sectionIsOnScreen
        // user is scrolling downwards only
        && scrollingDown
      ) {
        if (!articles.loading && !articles.loadEnd) {
          infiniteScroll(articles.currentUrl);
        }
      }

      scrollPos = window.pageYOffset;
    }));

    // Update category filter
    $categoryInput.on('change', debounce(300, (e) => {
      // do nothing if api data hasn't loaded
      if (!articles.initial.length || !categories || !locations) return;

      const { value } = e.currentTarget;
      // clear location filter
      $locationInput.val('');

      if (value === '') {
        articles.setState({
          current: articles.initial,
          currentUrl: defaultUrl,
          currentPage: 0,
          loadEnd: false,
        });
        setResults(articles.current);
        return;
      }

      articles.setState({
        currentUrl: `${defaultUrl}&category_id=${value}`,
      });

      // show loading spinner
      $results.html('<div class="c-team-filter__loader"></div>');

      getFilterResults();
    }));

    // Update location filter
    $locationInput.on('change', debounce(300, (e) => {
      // do nothing if api data hasn't loaded
      if (!articles.initial.length || !categories || !locations) return;

      const { value } = e.currentTarget;
      // clear category filter
      $categoryInput.val('');

      if (value === '') {
        articles.setState({
          current: articles.initial,
          currentUrl: defaultUrl,
          loadEnd: false,
          currentPage: 0,
        });
        setResults(articles.current);
        return;
      }

      articles.setState({ currentUrl: `${defaultUrl}&location_id=${value}` });

      // show loading spinner
      $results.html('<div class="c-team-filter__loader"></div>');

      getFilterResults();
    }));
  }(jQuery));
};

export default newsFilter;
